import React, { createContext, useContext } from 'react';
import { BusinessVisitRepository, ContactLeadRepository } from './BaseRepository';
import { SupabaseBusinessVisitRepository, SupabaseContactLeadRepository } from './SupabaseRepository';
import { supabase } from '../config/supabase';

interface RepositoryContextType {
  businessVisitRepository: BusinessVisitRepository;
  contactLeadRepository: ContactLeadRepository;
}

const RepositoryContext = createContext<RepositoryContextType | null>(null);

export const useRepositories = () => {
  const context = useContext(RepositoryContext);
  if (!context) {
    throw new Error('useRepositories must be used within a RepositoryProvider');
  }
  return context;
};

interface RepositoryProviderProps {
  children: React.ReactNode;
  businessVisitRepository?: BusinessVisitRepository;
  contactLeadRepository?: ContactLeadRepository;
}

export const RepositoryProvider: React.FC<RepositoryProviderProps> = ({
  children,
  businessVisitRepository = new SupabaseBusinessVisitRepository(supabase),
  contactLeadRepository = new SupabaseContactLeadRepository(supabase),
}) => {
  return (
    <RepositoryContext.Provider
      value={{
        businessVisitRepository,
        contactLeadRepository,
      }}
    >
      {children}
    </RepositoryContext.Provider>
  );
}; 